import React from 'react';
import { Link } from 'react-router';
import DataTable from "../../DataTable";
import { inject, observer } from "mobx-react/index";
import { observable, toJS } from 'mobx';
import Spinner from "../../Spinner";

@inject('imageSourceStore', 'imageSourceDeviceStore', 'stationStore')
@observer
class ImageSourceDeviceList extends React.Component {

  @observable items = [];

  componentWillMount() {
    const { params: { id } } = this.props;
    this.handleDelete = this.handleDelete.bind(this);
    this.populateItems(id);
  }

  componentWillReceiveProps(nextProps) {
    const { params: { id } } = this.props;
    if (+id !== +nextProps.params.id) this.populateItems(nextProps.params.id)
  }

  populateItems = (id) => {
    const { imageSourceDeviceStore } = this.props;
    imageSourceDeviceStore.fetchBySource(id);
  };

  handleDelete(idOrIds) {
    this.props.imageSourceDeviceStore.removeItems(idOrIds);
  }

  render() {
    const { imageSourceStore, imageSourceDeviceStore, stationStore, params: { id } } = this.props;
    if (imageSourceStore.isLoading || imageSourceDeviceStore.isLoading) return <Spinner />;

    const imageSource = imageSourceStore.findById(id);
    let items = imageSourceDeviceStore.items.filter(item => +item.imagesource_id === +id).map(item => {
      let station = stationStore.findById(item.station_id)
      return Object.assign({}, item, { station: !!station && <Link to={`/station/${station.id}/images`}>{station.name}</Link> })
    });

    return (
      <div>
        <DataTable
          data={items}
          slug={`idaq/image_source/${id}/devices`}
          columns={[
            { key: 'id', label: 'ID' },
            { key: 'device_code', label: 'Device Code' },
            { key: 'station', label: 'Station' },
          ]}
          onDelete={this.handleDelete}
          caption={`${imageSource.name} devices`}
          allowAdd
          allowEdit
          allowDelete
          resource='idaq'
        />
        {this.props.children}
      </div>
    );
  }
}

export default ImageSourceDeviceList;


// WEBPACK FOOTER //
// ./src/components/IDaq/ImageSourceDevices/ImageSourceDeviceList.js